/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '@pages/EventTrackerPage/config/event.tracking.config.json';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';

import { GET_ANALYTICS_DETAIL } from '@pages/EventTrackerPage/apis/graphql';
import { vappContainer } from '@/application';

import { toHeaderCase, toLowerCase, toSentenceCase } from 'js-convert-case';

import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator/services';

import { usePolicyId } from '@pages/EventTrackerPage/provider';

const moment = require('moment');

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IEventTrackerPageMethods extends IPluginMethodMap {
  getEventTrackerPageProps(args: any): Promise<any>;
}

const lookup = require('country-code-lookup');

export class EventTrackerPagePlugin implements IAgentPlugin {
  readonly methods: IEventTrackerPageMethods;

  constructor() {
    this.methods = {
      getEventTrackerPageProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    try {
      const res = await this.getTracker(args);
      if (res) return res;
    } catch (err: any) {
      // Fallback to static configuration if API fails
    }
    return { ...config };
  }

  private async getTracker(args: any) {
    const { policyNumber } = usePolicyId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);

      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_ANALYTICS_DETAIL, {
          input: {
            policyId: policyNumber,
            month: parseInt(args?.month),
          },
        })
        .toPromise();
      if (res?.data?.getPolicyAnalytics) {
        return {
          ...config,
          events: this.getEvents(res?.data?.getPolicyAnalytics),
          isEmpty:
            res?.data?.getPolicyAnalytics?.data?.length === 0 ? true : false,
        };
      }
    } catch (err: any) {
      // log.error('error in capsules=', err?.message);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
  private getEvents(data: any[]) {
    let _temp: any = [];
    if (Array.isArray(data) && data?.length > 0) {
      data.forEach((ele) => {
        if (Array.isArray(ele?.events) && ele?.events?.length > 0) {
          console.log(`date format`);
          ele?.events.forEach((element: any) => {
            _temp.push({
              id: element?.title,
              date: moment(ele?.date).format('YYYY-MM-DD'),
              title: toHeaderCase(element?.title),
              color: this.getColor(element?.title),
              data: {
                data: this.getModalData(element, ele?.blockchainTxnUrl),
                numberOfColumns: '2',
              },
            });
          });
        }
      });
    }
    return _temp;
  }

  private getColor(color: string) {
    switch (color) {
      case 'Tropical Cyclone Occurred':
        return '#DB111D';
      case 'Eligible For Payout':
        return '#2A7E19';
      default:
        return '#FE601F';
    }
  }

  private getModalData(data: any, id: string) {
    console.log(`Get Modal Data`, data);
    let _tmp: any = [];
    for (const [key, value] of Object.entries(data)) {
      if (key !== 'title' && value) {
        _tmp.push({
          key: id,
          title: toHeaderCase(key),
          subTitle: value,
        });
      }
    }

    if (id) {
      _tmp.push({
        key: id,
        title: 'Transaction Receipt',
        subTitle: id,
      });
    }
    return _tmp;
  }
}
